import {ElementModel} from "models/headerModel"

const ValidateBannerData = (banner: ElementModel | null): boolean =>
    !!(banner && banner.icon && banner.url && banner.text)

export default ValidateBannerData
